angular.module('jrLinkToInbox', ['jrConfig', 'jrUtil']).service('LinkToInboxService', [
  'LinkToInboxConfig',
  '$filter',
  function (LinkToInboxConfig, $filter) {
    function findProvider(email) {
      return LinkToInboxConfig.enabled
        ? $filter('emailDomainMatch')(LinkToInboxConfig.providersList, email, -1)
        : [];
    }
    return {
      findProvider,
    };
  },
]);
